import SetupHikSerialNumberSmsModal from './setup-hik-serial-number-sms-modal.vue'
export default SetupHikSerialNumberSmsModal
